import { render, staticRenderFns } from "./viewer.vue?vue&type=template&id=15b561bc&scoped=true"
import script from "./viewer.vue?vue&type=script&lang=js"
export * from "./viewer.vue?vue&type=script&lang=js"
import style0 from "./viewer.vue?vue&type=style&index=0&id=15b561bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b561bc",
  null
  
)

export default component.exports